export const conflictResources = {
  scripts: [
    {
      id: 'starter',
      title: 'Åpne samtalen',
      description: 'Hvordan invitere til en vanskelig samtale uten å skape forsvarsposisjon.',
      steps: [
        { label: 'Observasjon', text: 'Jeg har lagt merke til at stemningen i teammøtene har endret seg i det siste...' },
        { label: 'Behov', text: 'For meg er det viktig at vi har et miljø der alle føler seg trygge på å dele ideer.' },
        { label: 'Spørsmål', text: 'Hvordan opplever du situasjonen fra ditt ståsted?' }
      ]
    },
    {
      id: 'feedback',
      title: 'Gi korrigerende tilbakemelding',
      description: 'Fokus på adferd fremfor personlighet.',
      steps: [
        { label: 'Spesifikk hendelse', text: 'I går da vi diskuterte prosjektplanen, avbrøt du kollegaen din tre ganger.' },
        { label: 'Konsekvens', text: 'Dette gjør at viktige innspill går tapt og skaper usikkerhet i gruppen.' },
        { label: 'Ønske', text: 'Jeg vil be deg om å la andre snakke ferdig før du kommer med dine motargumenter.' }
      ]
    }
  ],
  techniques: [
    {
      title: 'Aktiv Lytting (L-U-T)',
      icon: 'Mic',
      desc: 'Lytt, Understøtt, Tolk. Essensielt for å de-eskalere emosjonelle konflikter.',
      color: 'indigo'
    },
    {
      title: 'I-budskap',
      icon: 'User',
      desc: 'Snakk ut fra egne opplevelser ("Jeg føler...") istedenfor anklager ("Du gjør alltid...").',
      color: 'emerald'
    },
    {
      title: 'Time-out',
      icon: 'Clock',
      desc: 'Når emosjonene tar overhånd, er det bedre å pause samtalen i 20 minutter.',
      color: 'rose'
    }
  ],
  mediationSteps: [
    { title: 'Forberedelse', desc: 'Sikre nøytralt grunnlag og avklar forventninger med hver part hver for seg.' },
    { title: 'Innledning', desc: 'Sett spilleregler: Respekt, lytte ferdig, fokus på løsning.' },
    { title: 'Historiefortelling', desc: 'Hver part får legge frem sin versjon uten avbrytelser.' },
    { title: 'Behovskartlegging', desc: 'Hva trenger partene egentlig for å gå videre? (Ikke bare hvem som har rett).' },
    { title: 'Løsningsforslag', desc: 'Brainstorming av mulige veier ut av situasjonen.' },
    { title: 'Avtale', desc: 'Skriftliggjøring av hva man er blitt enige om og hvordan det skal følges opp.' }
  ]
};